import {
  call,
  put,
  fork,
  takeLatest
} from 'redux-saga/effects';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  LOAD_CONTENT,
  DL_PAGE_LOADED
} from './omniLanding';
import {
  showGlobalSpinner
} from '../../../common/common';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

// WORKERS
export function* loadContentWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true}));

    const success = yield call(dataProvider.load, [
			{state: 'omniPrerequisites'}
    ]);

    if (!success) {
      return;
		}

    yield put({
      type: DL_PAGE_LOADED
    });

  } catch(e) {
    //
  }
}

export default function* omniLandingSagas() {
  yield [
    fork(loadContentWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/omni/omniLandingSagas.js
 **/